var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Dropdown", {
        scopedSlots: _vm._u([
          {
            key: "dropdown-button",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass:
                      "inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150",
                    attrs: {
                      type: "button",
                      id: "options-menu",
                      "aria-haspopup": "true",
                      "aria-expanded": "true"
                    }
                  },
                  [
                    _vm._v(" Send Message "),
                    _c(
                      "svg",
                      {
                        staticClass: "-mr-1 ml-2 h-5 w-5",
                        attrs: { fill: "currentColor", viewBox: "0 0 20 20" }
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            d:
                              "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                            "clip-rule": "evenodd"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            },
            proxy: true
          },
          {
            key: "dropdown-content",
            fn: function() {
              return [
                !_vm.isInShopifyMobileApp
                  ? _c(
                      "div",
                      { staticClass: "py-1" },
                      _vm._l(_vm.orderTemplates, function(template) {
                        return _c(
                          "a",
                          {
                            key: template.id,
                            staticClass:
                              "block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900",
                            attrs: { href: "#", role: "menuitem" },
                            on: {
                              click: function($event) {
                                return _vm.itemClicked(template)
                              }
                            }
                          },
                          [_vm._v(_vm._s(template.name) + " ")]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.isInShopifyMobileApp
                  ? _c(
                      "div",
                      { staticClass: "py-1" },
                      _vm._l(_vm.orderTemplates, function(template) {
                        return _c(
                          "a",
                          {
                            key: template.id,
                            staticClass:
                              "block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900",
                            attrs: {
                              href: _vm.getWhatsappHref(template),
                              role: "menuitem"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleHrefClick(template)
                              }
                            }
                          },
                          [_vm._v(_vm._s(template.name) + " ")]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm.isPlanExceeded
        ? _c("PlanExceededModal", {
            on: {
              close: function($event) {
                _vm.isPlanExceeded = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }